import { tsValidateArray, tsValidateEnum, tsValidateExists, tsValidateOptional, tsValidateUniqueId } from '@nu-art/ts-common';
import { TransitionMethod } from './types.js';
import { AdvisorRuntimeIDBGroup, Validator_EncounterId } from '../../_core/index.js';
const Validator_ModifiableProps = {
    ...Validator_EncounterId,
    stateDbId: tsValidateUniqueId,
    missingPreconditions: tsValidateArray(tsValidateOptional),
    transitionsConditions: tsValidateExists(),
    transitionsMissingHvs: tsValidateExists(),
    transitionsCalcResults: tsValidateExists(),
    transitionMethod: tsValidateEnum(TransitionMethod, false),
    sourceTransitionId: tsValidateUniqueId,
};
const Validator_GeneratedProps = {};
export const DBDef_RuntimeActiveNavState = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'redis-active-nav-states',
    entityName: 'ActiveNavState',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'redis-active-nav-states'
    },
    backend: {
        name: 'redis-active-nav-states'
    }
};
//# sourceMappingURL=db-def.js.map